import React from 'react';
import pluralize from 'pluralize';
import Box from '@material-ui/core/Box';
import { BarChart } from '../BarChart/BarChart.esm.js';
import { BarChartLegend } from '../BarChart/BarChartLegend.esm.js';
import 'classnames';
import '@material-ui/core/Divider';
import '@material-ui/core/Typography';
import { useBarChartLayoutStyles } from '../../utils/styles.esm.js';
import '@material-ui/icons/Lens';
import { InfoCard } from '@backstage/core-components';

const UnlabeledDataflowAlertCard = ({
  alert
}) => {
  const classes = useBarChartLayoutStyles();
  const projects = pluralize("project", alert.projects.length, true);
  const subheader = `
    Showing costs from ${projects} with unlabeled Dataflow jobs in the last 30 days.
  `;
  const options = {
    previousName: "Unlabeled Cost",
    currentName: "Labeled Cost"
  };
  const resources = alert.projects.map((project) => ({
    name: project.id,
    previous: project.unlabeledCost,
    current: project.labeledCost
  }));
  return /* @__PURE__ */ React.createElement(InfoCard, { title: "Label Dataflow", subheader }, /* @__PURE__ */ React.createElement(Box, { className: classes.wrapper }, /* @__PURE__ */ React.createElement(
    BarChartLegend,
    {
      costStart: alert.unlabeledCost,
      costEnd: alert.labeledCost,
      options
    }
  ), /* @__PURE__ */ React.createElement(BarChart, { resources, options })));
};

export { UnlabeledDataflowAlertCard };
//# sourceMappingURL=UnlabeledDataflowAlertCard.esm.js.map
